import { styled } from '@mui/material';

export const Wrapper = styled('div')({
    maxWidth: 1040,
    margin: '0 auto',
});
